<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;">
			<v-card flat>
				<v-card-text>
					<v-form ref="form">
						<v-row>
							<v-col cols="12">
								<v-text-field
									label="VIN-код"
									v-model="params.vin"
									outlined
									dense
									clearable
									@keyup.ctrl.90="params.vin='WAUC8AFC0HN089495'"
									@keyup.enter.self="onOK"
									hide-details="auto"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<v-list dense nav>
				<!-- PDF -->
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>

				<!-- Excel -->
				<!-- <v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<download-excel 
									:data="excel.data"
									:name="excel.name"
									:type="excel.type"
								>
									<v-icon color="green darken-2" :disabled="excel.disabled" v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
								</download-excel>
							</template>
							<span>Експорт Excel</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item> -->

				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon v-bind="attrs" v-on="{ ...tooltip }" @click="notEmpty=!notEmpty">{{ notEmpty ? 'mdi-circle-half-full' : 'mdi-moon-full' }}</v-icon>
							</template>
							<span v-if="notEmpty">Зі значенням</span>
							<span v-else>Всі дані</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
			</v-list>
        </v-navigation-drawer>

		
		<v-container style="padding: 64px 0px 0px 256px;">
			<v-breadcrumbs :items="crumbs" divider="-" ></v-breadcrumbs>
		
			<v-card flat>
				<v-card-title class="font-weight-light">
					{{ title }}
				</v-card-title>

				<v-divider></v-divider>

				<v-card-text>
					<v-data-table v-if="equipments.length"
						:headers="headers"
						:items="equipments"
						hide-default-footer
						disable-pagination
					></v-data-table>
					<!-- <v-simple-table dense fixed-header>
						<template v-slot:default>
						<thead>
							<tr>
								<th class="text-left">Код</th>
								<th class="text-left">Назва</th>
								<th class="text-left">Значення</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(equipment, index) in equipments" :key="index">
								<td>{{ equipment.VariableId }}</td>
								<td>{{ equipment.Variable }}</td>
								<td>{{ equipment.Value }}</td>
								<td>{{ equipment.ValueId }}</td>
							</tr>
						</tbody>
						</template>
					</v-simple-table> -->
				</v-card-text>
			</v-card>
		</v-container>
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>

		<z-pdf ref="pdf" :code="code" :name="name"></z-pdf>
	</v-main>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import mixin from './mixin/main'
// import downloadExcel from "vue-json-excel"

export default {
	mixins: [mixin],
	components: { },
	data: () => ({
		notEmpty: true,

		headers: [
			{ text: 'Код', value: 'VariableId' },
			{ text: 'Назва', value: 'Variable' },
			{ text: 'Значення', value: 'Value' },
		],
	}),

	props: {
		code: 				{ type: String, default: 'VehicleVinDecoding' },
		name: 				{ type: String, default: 'Ідентифікація транспортного засобу за VIN-кодом' },
		vin: 				{ type: String },
	},


	computed: {
		equipments() {
			//return this.data?.Results ? (this.notEmpty ? this.data.Results.filter(element => element.Value !== "" && element.Value !== null) : this.data.Results) : [];
			return this.data?.Results ? (this.notEmpty ? this.data.Results.filter(element => element.Value) : this.data.Results) : [];
		},
	},

	methods: {
		onOK() {
			var that = this

			this.clearData()

			if (this.$refs.form.validate()) {
				//console.log(this.$options.name, 'onOK', 'VALID')
				//console.log(this.$options.name, 'params', this.urlParams())

				this.loading = true
				axios.get(`/nhtsa/vin/${this.params.vin}`).then(response => {
					console.log(that.$options.name, 'onOK','response.data', response.data)
					that.setData(response.data)
				}, error => {
					console.log('error', error)

					that.snackbar.visible 	= true;
					that.snackbar.text 		= error.response.data.message;
					that.snackbar.color 	= null;
				}).finally(() => {
					this.loading = false
				});
			}
		},

		clearData() {
			this.setData({})
			/* this.setData({
				datasets: {
					ds: {},
					ds2: {},
				}
			}) */
		},
	},
}
</script>